module.exports = __webpack_public_path__ + "static/img/product2.bc98fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product2.png
// module id = 1LOv
// module chunks = 0